import styled from "@emotion/styled";

export const Container = styled.div`
  position: relative;
  background-color: white;
`;
